import initAssistance from './initAssistance';

export default initAssistance;
